import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
const PrevArrow = (props) => {
  const { className, style, onClick, color } = props;
  return (
    <>
      <FontAwesomeIcon
        className={className}
        onClick={onClick}
        style={{
          ...style,
          zIndex: 2,
          height: "100px",
          color: color,
        }}
        icon={faAngleLeft}
      />
    </>
  );
};
export default PrevArrow;
